export interface IEidasInformation {
    guid: string;
    personIdentifier: string;
}

export const newEidasInformationInit: IEidasInformation = {
    guid: "",
    personIdentifier: "",
};
